import { Dialog } from '@material-ui/core';
import React from 'react';

const useDialog = () => {
    const [opened, setOpened] = React.useState(false);
    const open = () => setOpened(true);
    const close = () => setOpened(false);

    const Container = (props) => (
        <Dialog open={opened} onClose={close} {...props} />
    );

    return [Container, open, close];
};

export default useDialog;
